
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","id":"Rating-Star-1--Streamline-Streamline--3.0.svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Rating Star 1 Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('rating-star-1')]),_c('path',{attrs:{"d":"m12.433 5.518 1.989 3.977 3.826 0.383a0.484 0.484 0 0 1 0.295 0.824l-3.153 3.152 1.169 4.283a0.485 0.485 0 0 1 -0.684 0.561L12 16.76 8.125 18.7a0.484 0.484 0 0 1 -0.683 -0.561l1.168 -4.285L5.457 10.7a0.484 0.484 0 0 1 0.295 -0.824l3.826 -0.383 1.989 -3.977a0.484 0.484 0 0 1 0.866 0.002Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    